import { useHasAccess } from "../../../hooks/useHasAccess";
import { Button } from "../../Button";
import { Dropdown } from "../../Dropdown";
import { Icon } from "../../Icon";
import { HoverActions } from "../shared";

export function NetworkRowActions({
  networkId,
  hasMouse,
  onRename,
  onDelete,
}: {
  networkId: string;
  hasMouse: boolean;
  onRename: () => void;
  onDelete: () => void;
}) {
  const canWrite = useHasAccess("network:write", networkId);
  const canManageNetworks = useHasAccess("tenant:networks_manage");
  if (!canWrite && !canManageNetworks) return null;

  return (
    <HoverActions visible={hasMouse}>
      <Dropdown
        opener={
          <Button
            variant="secondary"
            icon="more"
            aria-label="Network actions"
          />
        }
        align="bottom"
        minWidth={160}
        sections={[
          {
            items: [
              {
                type: "button",
                left: <Icon name="pencil" size={16} />,
                label: "Rename",
                onClick: onRename,
              },
              {
                type: "button",
                left: <Icon name="trash" size={16} />,
                label: "Delete",
                onClick: onDelete,
              },
            ],
          },
        ]}
      />
    </HoverActions>
  );
}
